import { fire, auth } from "../../firebase/index";
import { customLog, deploymentEnvironment } from "../../variables/Variables";

// const randomString = require("randomstring");
const DB = fire.database();

const updateEmail = async (
  oldEmail,
  newEmail,
  superAdminID,
  currentUserID,
  currentUserEmail,
  userName
) => {
  const today = Math.floor(new Date());

  let USER = auth.currentUser;

  const userGrpsRef = DB.ref("groupAccounts")
    .child(superAdminID)
    .child("userGroups");
  const membersRef = DB.ref("groupAccounts")
    .child(superAdminID)
    .child("members");
  const grpManageRef = DB.ref("GroupManagement").child(superAdminID);

  let activityLogsDB = fire
    .database()
    .ref("individualActivities")
    .child(currentUserID);
  let activityKey = activityLogsDB.push().key;

  let notifyLogsDB = fire
    .database()
    .ref("individualNotifications")
    .child(superAdminID);
  let notifyKey = notifyLogsDB.push().key;

  let language = "";

  await DB.ref("userSettings")
    .child(currentUserID)
    .once("value")
    .then((settings) => {
      language = settings.val().language;
    });

  try {
    await USER.updateEmail(newEmail);

    //update notification tab for super admin

    await membersRef
      .orderByChild("memberEmail")
      .equalTo(currentUserEmail)
      .once("value")
      .then((snapshotVal) => {
        snapshotVal.forEach((snapshot) => {
          let memberName = snapshot.val().memberName;
          let isSuperAdmin = snapshot.child("isSuperAdmin").exists()
            ? snapshot.val().isSuperAdmin
            : false;
          if (isSuperAdmin !== true) {
            notifyLogsDB.child(notifyKey).update({
              notificationType: 4,
              description: "Email has been successfully updated",
              detailedDescription: "",
              platform: "Web App",
              isRead: false,
              snapKey: notifyKey,
              memberName: memberName,
              memberUid: currentUserID,
              oldEmail: oldEmail,
              newEmail: newEmail,
              timeStamp: today,
              // test: "hello this is a test update"
            });
          }
        });
      });

    //update email in registeredIndustrialUsersOnPlatform\

    await DB.ref("registeredIndustrialUsersOnPlatform/" + currentUserID).update(
      {
        email: newEmail,
      }
    );

    //change email in retractableSharingRegistry + multiSharingAdmins & userFriendListIndustrial
    await membersRef.once("value").then((snapshots) => {
      snapshots.forEach((snapshots) => {
        let memberEmails = snapshots.val().memberEmail;

        DB.ref("registeredUsersOnPlatform")
          .orderByValue()
          .equalTo(memberEmails)
          .once("value")
          .then((snapshot) => {
            snapshot.forEach((snapshotValue) => {
              let eachMemberUID = snapshotValue.key;

              DB.ref("userFriendListIndustrial")
                .child(eachMemberUID)
                .orderByChild("friendEmail")
                .equalTo(currentUserEmail)
                .once("value")
                .then((snapshotFriendList) => {
                  snapshotFriendList.forEach((snapshotValueFriendList) => {
                    snapshotValueFriendList.ref
                      // .child("friendEmail")
                      .update({
                        friendEmail: newEmail,
                      });
                  });
                });

              DB.ref("retractableSharingRegistry")
                .child(eachMemberUID)
                .orderByChild("sharedToEmail")
                .equalTo(currentUserEmail)
                .once("value")
                .then((snapshotRSR) => {
                  snapshotRSR.forEach((snapshotRSRValue) => {
                    snapshotRSRValue.ref
                      // .child("sharedToEmail")
                      .update({
                        sharedToEmail: newEmail,
                      });
                  });
                });

              DB.ref("retractableSharingRegistry")
                .child(eachMemberUID)
                .once("value")
                .then((snapshotRSRmulti) => {
                  snapshotRSRmulti.forEach((snapshotRSRmultiSnapKeys) => {
                    snapshotRSRmultiSnapKeys.ref
                      .child("multiSharingAdmins")
                      .orderByChild("adminEmail")
                      .equalTo(currentUserEmail)
                      .once("value")
                      .then((snapshotMultiSharingAdmins) => {
                        snapshotMultiSharingAdmins.forEach(
                          (snapshotMultiSharingAdminsValue) => {
                            snapshotMultiSharingAdminsValue.ref
                              // .child("adminEmail")
                              .update({
                                adminEmail: newEmail,
                              });
                          }
                        );
                      });
                  });
                });
            });
          });
      });
    });

    //update memberEmail in GroupManagement
    await grpManageRef.once("value").then((snapshot) => {
      snapshot.forEach((UID) => {
        var memberID = UID.key;

        grpManageRef
          .child(memberID)
          .orderByChild("groupMembers/" + currentUserID + "/memberEmail")
          .equalTo(currentUserEmail)
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach((snapVal) => {
                snapVal.ref
                  .child("groupMembers")
                  .child(currentUserID)
                  .update({
                    memberEmail: newEmail,
                  });
              });
            }
          });
      });
    });

    //update email in groupAccounts members : memberEmail
    await membersRef
      .orderByChild("memberEmail")
      .equalTo(currentUserEmail)
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((membersSnap) => {
          var MEMBER_UID = membersSnap.val().memberUid;
          snapshot.ref.child(MEMBER_UID).update({
            memberEmail: newEmail,
          });
        });
      });

    //update email in userGroups: groupAdminEmail
    await userGrpsRef.once("value").then((snapshot) => {
      snapshot.forEach((snapval) => {
        var uid = snapval.key;
        userGrpsRef
          .child(uid)
          .child("groups")
          .orderByChild("groupAdminEmail")
          .equalTo(currentUserEmail)
          .once("value")
          .then((userSnaps) => {
            if (userSnaps.exists()) {
              userSnaps.forEach((snap) => {
                snap.ref.update({
                  groupAdminEmail: newEmail,
                });
              });
            }
          });
      });
    });

    //update email in userGroups : memberEmail
    await userGrpsRef.child(currentUserID).update({
      memberEmail: newEmail,
    });

    //update email in registeredUsersOnPlatform
    await DB.ref("registeredUsersOnPlatform/" + currentUserID).set(newEmail);

    //update activity tab for user
    await activityLogsDB.child(activityKey).update({
      activityType: 8,
      description: "Email has been updated",
      detailedDescription: "",
      // isRead: false,
      oldEmail: oldEmail,
      newEmail: newEmail,
      userEmail: currentUserEmail,
      platform: "Web App",
      userUID: currentUserID,
      snapKey: activityKey,
      timeStamp: today,
    });

    // send email notification
    const dataToPost = {
      newemail: newEmail,
      oldemail: oldEmail,
      name: userName,
      language: language,
    };

    await fetch(
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/notifyEmailChange",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToPost),
      }
    ).then(() => {
      alert("New Email has been updated successfully!");
      document.location.reload();
    });
  } catch (e) {
    if (e.code === "auth/email-already-in-use") {
      customLog(`error email is already in use  + ${e.message}`);
    } else if (e.code === "auth/requires-recent-login") {
      customLog(`session expired, pls log in again  + ${e.message}`);
    } else {
      customLog(`unknown error occured + ${e.message}`);
    }
  }

  return true;
};

export { updateEmail };
